import api from './api';

// ========== EMAIL TEMPLATES ==========

export const getEmailTemplates = async () => {
  const response = await api.get('/templates/email');
  return response.data;
};

export const getEmailTemplate = async (code) => {
  const response = await api.get(`/templates/email/${code}`);
  return response.data;
};

export const updateEmailTemplate = async (code, data) => {
  const response = await api.put(`/templates/email/${code}`, data);
  return response.data;
};

export const previewEmailTemplate = async (code, variables) => {
  const response = await api.post(`/templates/email/${code}/preview`, { variables });
  return response.data;
};

// ========== WHATSAPP TEMPLATES ==========

export const getWhatsAppTemplates = async () => {
  const response = await api.get('/templates/whatsapp');
  return response.data;
};

export const getWhatsAppTemplate = async (code) => {
  const response = await api.get(`/templates/whatsapp/${code}`);
  return response.data;
};

export const updateWhatsAppTemplate = async (code, data) => {
  const response = await api.put(`/templates/whatsapp/${code}`, data);
  return response.data;
};

export const previewWhatsAppTemplate = async (code, variables) => {
  const response = await api.post(`/templates/whatsapp/${code}/preview`, { variables });
  return response.data;
};
